var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SouthAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M42.716,17C39.875,9.412,32.579,4,24,4c-3.463,0-6.72,0.881-9.56,2.43L28.535,17H42.716z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M28.535,31L14.44,41.57C17.28,43.119,20.537,44,24,44c8.579,0,15.875-5.412,18.716-13H28.535z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.598,20c-0.21-1.034-0.52-2.03-0.883-3h-14.18L14.44,6.43c-0.868,0.473-1.684,1.026-2.468,1.618 L28,20H43.598z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.716,31c0.363-0.97,0.673-1.966,0.883-3H28L11.971,39.951c0.784,0.592,1.6,1.145,2.468,1.618 L28.535,31H42.716z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M43.598,28C43.861,26.707,44,25.37,44,24s-0.139-2.707-0.402-4H28L11.971,8.049 c-2.264,1.71-4.165,3.874-5.534,6.379L19.2,24L6.437,33.572c1.368,2.505,3.27,4.669,5.534,6.379L28,28H43.598z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M6.437,14.428c-0.457,0.836-0.836,1.718-1.171,2.621L14.535,24l-9.269,6.951 c0.335,0.903,0.714,1.785,1.171,2.621L19.2,24L6.437,14.428z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M5.266,17.049C4.461,19.217,4,21.552,4,24s0.461,4.783,1.266,6.951L14.535,24L5.266,17.049z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SouthAfrica);
export default __webpack_public_path__ + "static/media/icons8-south-africa.e076692f48235975ef92f7204220ce78.svg";
export { ForwardRef as ReactComponent };